import { GenericDomainError } from '../../../types/errors/generic-domain-error';
/**
 * Known error codes that are returned by the Loyalty Domain
 */
export var LoyaltyDomainSpecificErrorCode;
(function (LoyaltyDomainSpecificErrorCode) {
    /**
     * No signed in member
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["NoSignedInMember"] = 30001] = "NoSignedInMember";
    /**
     * Invalid credentials
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["InvalidCredentials"] = 30002] = "InvalidCredentials";
    /**
     * Invalid email format
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["InvalidEmailFormat"] = 30009] = "InvalidEmailFormat";
    /**
     * The email used is already registered
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["EmailAlreadyRegistered"] = 30010] = "EmailAlreadyRegistered";
    /**
     * The username used is already registered
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["UsernameAlreadyRegistered"] = 30011] = "UsernameAlreadyRegistered";
    /**
     * A member already exists with the provided unique identifier
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["MemberIdentifierNotUnique"] = 30012] = "MemberIdentifierNotUnique";
    /**
     * The password provided for the authenticated member is invalid
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["InvalidCurrentPassword"] = 30013] = "InvalidCurrentPassword";
    /**
     * Subscription billing option not found
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["SubscriptionBillingOptionNotFound"] = 30014] = "SubscriptionBillingOptionNotFound";
    /**
     * Selected subscription billing option is not recurring
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["SubscriptionBillingOptionNotRecurring"] = 30015] = "SubscriptionBillingOptionNotRecurring";
    /**
     * Current member does not have any existing subscriptions
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["CurrentSubscriptionDoesNotExist"] = 30016] = "CurrentSubscriptionDoesNotExist";
    /**
     * Current subscription is frozen
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["CurrentSubscriptionFrozen"] = 30017] = "CurrentSubscriptionFrozen";
    /**
     * Current member uses non-Vista payment for subscription billing
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["CurrentSubscriptionNonVistaPayment"] = 30018] = "CurrentSubscriptionNonVistaPayment";
    /**
     * Current member cannot purchase future subscriptions
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["FutureSubscriptionCannotBeSet"] = 30019] = "FutureSubscriptionCannotBeSet";
    /**
     * Current member does not have a primary card
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["PrimaryPaymentCardNotFound"] = 30020] = "PrimaryPaymentCardNotFound";
    /**
     * Password exceeds the value for maximum password length.
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["PasswordMaximumLengthExceeded"] = 30021] = "PasswordMaximumLengthExceeded";
    /**
     * Password doesn't meet the requirements for minimum password length.
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["PasswordMinimumLengthNotMet"] = 30022] = "PasswordMinimumLengthNotMet";
    /**
     * Password doesn't meet the requirements for minimum number of included numeric characters.
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["PasswordMinimumNumericCharactersNotMet"] = 30023] = "PasswordMinimumNumericCharactersNotMet";
    /**
     * Password doesn't meet the requirements for minimum number of included non-numeric characters.
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["PasswordMinimumNonNumericCharactersNotMet"] = 30024] = "PasswordMinimumNonNumericCharactersNotMet";
    /**
     * Password doesn't meet the requirements for minimum number of included distinct characters.
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["PasswordMinimumDistinctCharactersNotMet"] = 30025] = "PasswordMinimumDistinctCharactersNotMet";
    /**
     * Password contains the user's email address.
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["PasswordContainsEmail"] = 30026] = "PasswordContainsEmail";
    /**
     * Password contains the user's username.
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["PasswordContainsUsername"] = 30027] = "PasswordContainsUsername";
    /**
     * Password contains the user's given name or surname.
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["PasswordContainsGivenOrSurname"] = 30028] = "PasswordContainsGivenOrSurname";
    /**
     * Password is a known compromised password.
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["PasswordKnownCompromised"] = 30029] = "PasswordKnownCompromised";
    /**
     * Password contains disallowed words.
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["PasswordContainsDisallowedWords"] = 30030] = "PasswordContainsDisallowedWords";
    /**
     * Password reset code is invalid.
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["PasswordResetCodeInvalid"] = 30031] = "PasswordResetCodeInvalid";
    /**
     * Email or username was not provided.
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["NoEmailOrUsername"] = 30032] = "NoEmailOrUsername";
    /**
     * Represents a loyalty member temporarily locked out of loyalty due to too many failed login attempts.
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["MemberLocked"] = 30033] = "MemberLocked";
    /**
     * Represents a loyalty members refresh token has expired.
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["RefreshTokenExpired"] = 30034] = "RefreshTokenExpired";
    /**
     * Current member does not have an active subscription.
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["MemberDoesNotHaveAnActiveSubscription"] = 30035] = "MemberDoesNotHaveAnActiveSubscription";
    /**
     * Current member has reached the maximum number of friends.
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["MembersFriendLimitReached"] = 30036] = "MembersFriendLimitReached";
    /**
     * Friend has reached the maximum number of friends.
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["FriendsFriendLimitReached"] = 30037] = "FriendsFriendLimitReached";
    /**
     * Friend code is invalid.
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["FriendCodeInvalid"] = 30038] = "FriendCodeInvalid";
    /**
     * Current member does not have a subscription.
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["MemberDoesNotHaveASubscription"] = 30039] = "MemberDoesNotHaveASubscription";
    /**
     * Friend code belongs to the member.
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["FriendCodeBelongsToMember"] = 30040] = "FriendCodeBelongsToMember";
    /**
     * Friend code belongs to an existing friend.
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["FriendCodeBelongsToExistingFriend"] = 30041] = "FriendCodeBelongsToExistingFriend";
    /**
     * Friend does not have an active subscription.
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["FriendDoesNotHaveAnActiveSubscription"] = 30042] = "FriendDoesNotHaveAnActiveSubscription";
    /**
     * Friend does not exist.
     */
    LoyaltyDomainSpecificErrorCode[LoyaltyDomainSpecificErrorCode["FriendDoesNotExist"] = 30043] = "FriendDoesNotExist";
})(LoyaltyDomainSpecificErrorCode || (LoyaltyDomainSpecificErrorCode = {}));
export class LoyaltyDomainError extends GenericDomainError {
    constructor(errorCode, errorCodeDescription, errorData, ...params) {
        super(errorCode, errorCodeDescription, errorData, ...params);
        Object.setPrototypeOf(this, LoyaltyDomainError.prototype);
    }
}
